import {Subject} from "rxjs";
import {DokumentId, Modelloppdatering, MøtedeltakerId, MøteId, OppdateringmodellEntitetMedForelder, OppdateringmodellKommentarMedForelder, OppdateringmodellKommentarOppgave, OppdateringmodellKommentarSak, OppdateringmodellMøteOgSak, OppdateringmodellSvarMedForelder} from "./ressurser/generertNg2HttpKlient";
import {Inject, Injectable} from "@angular/core";
import {ajs_ModelloppdateringTjeneste_DI_TOKEN, AjsModelloppdateringTjeneste} from "./ajs/AjsModelloppdateringTjeneste";

@Injectable({providedIn: 'root'})
export class Modelloppdateringer {

    constructor(@Inject(ajs_ModelloppdateringTjeneste_DI_TOKEN) private ajsModelloppdateringTjeneste: AjsModelloppdateringTjeneste) {
    }

    get hendelser(): Subject<Modelloppdatering<any>> {
        return this.ajsModelloppdateringTjeneste.hendelser;
    }

    broadcastLokalNyttMøte(møteId: MøteId): void {
        this.ajsModelloppdateringTjeneste.broadcastLokalNyttMøte(møteId);
    }

    broadcastLokalSignatarSignert(dokumentId: DokumentId): void {
        this.ajsModelloppdateringTjeneste.broadcastLokalSignatarSignert(dokumentId);
    }

    broadcastLokalMøtedeltakerOppdatert(deltakerId: MøtedeltakerId, møteId: MøteId): void {
        this.ajsModelloppdateringTjeneste.broadcastLokalMøtedeltakerOppdatert(deltakerId, møteId);
    }

    broadcastLokalModellOppdatert(eventId: string, modell: any): void {
        this.ajsModelloppdateringTjeneste.broadcastLokalModellOppdatert(eventId, modell);
    }
}


export function finnMøteIdBlantForeldre(hendelseModell: OppdateringmodellEntitetMedForelder): MøteId | null {
    return hendelseModell.foreldre.find(forelder => forelder.type == 'Møte')?.id ?? null;
}

// definisjon av modeller benyttet i Modelloppdatering.modell
// merk at vi her kun definerer typer for Modelloppdatering.modell som ikke allerede er unikt definert i
// generertNg2HttpKlient.ts

// kommentar

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#nyKommentarSak */
export type OppdateringmodellNyKommentarSak = OppdateringmodellKommentarSak

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#nyKommentarOppgave */
export type OppdateringmodellNyKommentarOppgave = OppdateringmodellKommentarOppgave

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#kommentarSlettet */
export type OppdateringmodellKommentarSlettet = OppdateringmodellKommentarMedForelder

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#svarSlettet */
export type OppdateringmodellSvarSlettet = OppdateringmodellSvarMedForelder

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#nyttSvar */
export type OppdateringmodellNyttSvar = OppdateringmodellKommentarMedForelder;

// sak

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#nySak */
export type OppdateringmodellNySak = OppdateringmodellEntitetMedForelder;

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#sakOppdatert */
export type OppdateringmodellSakOppdatert = OppdateringmodellEntitetMedForelder;

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#sakReferatOppdatert */
export type OppdateringmodellSakReferatOppdatert = OppdateringmodellMøteOgSak

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#sakSlettet */
export type OppdateringmodellSakSlettet = OppdateringmodellMøteOgSak

// møte

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#nyttMøte */
export type OppdateringmodellNyttMøte = MøteId

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#møteOppdatert */
export type OppdateringmodellMøteOppdatert = MøteId

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#møteAvstemningÅpnet */
export type OppdateringmodellMøteAvstemningÅpnet = MøteId

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#møteAvstemningStengt */
export type OppdateringmodellMøteAvstemningStengt = MøteId

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#møteSlettet */
export type OppdateringmodellMøteSlettet = MøteId

/** no.systemfabrikken.lederplan.tjenester.pushmeldinger.ModelloppdateringBygger#saksrekkefølgeOppdatert */
export type OppdateringmodellSaksrekkefølgeOppdatert = MøteId
